import { Grid } from '@material-ui/core';
import React from 'react';

import signAndStampStyles from '../SignAndStamp/SignAndStamp.styles';

interface Props {
  message: string;
}

const SignAndStampNoImage: React.FC<Props> = ({ message = 'No Data' }) => {
  const classes = signAndStampStyles();

  return (
    <Grid xs={12} container className={classes.signUploadContainer}>
      <Grid item xs={3} className={classes.noImageDiv}>
        <Grid>{message}</Grid>
      </Grid>
    </Grid>
  );
};

export default SignAndStampNoImage;
